export default Object.freeze({
  Registro: 1,
  PEI: 2,  
})